import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Col } from "react-bootstrap";
import { useFormik } from "formik";
import { post, put, get, updateToken } from "../../../../../helpers/api_helper";
import add_stock from "../../../../../Assets/svg/stockExchange/add_stock.svg";
import { masterPlanetSchema } from "../../../../../helpers/yup_validator";
import toast from "react-hot-toast";
import { PLANET_NAMES } from "../../../../../helpers/constants";
import { useSelector } from "react-redux";
import { useGetAllStocksQuery } from "../../../../../store/services/utility.service";

const AddNewMasterPlanet = ({
  showModal,
  setShowModal,
  handleDataRefresh,
  mode,
  masterPlanetData,
  resetFormOnClose,
}) => {
  const token = useSelector((state) => state.login.token);

  const {data: stocks, isLoading: loadingStocks} = useGetAllStocksQuery({});

  useEffect(() => {
    if (token) {
      updateToken(token);
    }
  }, [token]);

  const formik = useFormik({
    initialValues: {
      name: "",
      stock: "",
      status: "active",
    },
    validationSchema: masterPlanetSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        if (mode === "create") {
          await post("/planet", { ...values, master: true });
          toast.success("Master planet created successfully");
        } else if (mode === "edit") {
          await put(`/planet/${masterPlanetData?._id}`, {
            ...values,
            master: true,
          });
          toast.success("Master planet updated successfully");
        }
        setShowModal(false);
        handleDataRefresh();
      } catch (error) {
        console.error("Error submitting master planet:", error);
        setErrors({
          submissionError: error.response?.data?.message
            ? error.response?.data?.message
            : error.response?.data?.error || "An error occurred.",
        });
        toast.error(
          error.response?.data?.message
            ? error.response?.data?.message
            : error.response?.data?.error || "An error occurred."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (mode === "edit" && masterPlanetData) {
      formik.setValues({
        name: masterPlanetData?.name,
        stock: masterPlanetData?.stock?._id,
        status: masterPlanetData?.status,
      });
    } else if (resetFormOnClose) {
      formik.resetForm();
    }
  }, [mode, masterPlanetData, resetFormOnClose]);

  return (
    <Modal
      show={showModal}
      size="md"
      onHide={() => setShowModal(false)}
      backdrop="static"
      keyboard={false}
      centered
      scrollable
    >
      <Modal.Body>
        <div className="topHeader d-flex align-items-start justify-content-between gap-10 pb-2">
          <div className="left">
            <h5 className="m-0 fw-sbold">
              {mode === "create"
                ? "Add New Master Planet"
                : "Edit Master Planet"}
            </h5>
            <p className="m-0 text-muted">
              {mode === "create"
                ? "Add a new master planet to the list."
                : "Edit the details of the master planet."}
            </p>
          </div>
          <Button
            className="p-0 border-0"
            variant="transparent"
            onClick={() => setShowModal(false)}
          >
            <img src={add_stock} alt="" />
          </Button>
        </div>
        <div className="FormWrapper">
          {formik.errors.submissionError && (
            <div className="alert alert-danger">
              {formik.errors.submissionError}
            </div>
          )}
          <Form onSubmit={formik.handleSubmit}>
            <Col className="my-2" lg="12">
              <label htmlFor="name" className="form-label text-dark m-0 pb-1">
                Name
              </label>
              <Form.Control
                as="select"
                id="name"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                className="form-control"
              >
                <option value="">Select a planet</option>
                {Object.keys(PLANET_NAMES).map((key) => (
                  <option key={key} value={key}>
                    {PLANET_NAMES[key]}
                  </option>
                ))}
              </Form.Control>
              {formik.touched.name && formik.errors.name ? (
                <div className="text-danger">{formik.errors.name}</div>
              ) : null}
            </Col>
            <Col className="my-2" lg="12">
              <label htmlFor="ticker" className="form-label text-dark m-0 pb-1">
                Ticker Name
              </label>
              <Form.Control
                as="select"
                id="stock"
                name="stock"
                value={formik.values.stock}
                onChange={formik.handleChange}
              >
                <option value="">Select a stock</option>
                {stocks?.map((stock) => (
                  <option key={stock?._id} value={stock?._id}>
                    {`${stock?.ticker_name} (${stock?.stock_name})`}
                  </option>
                ))}
              </Form.Control>
              {formik.touched.stock && formik.errors.stock ? (
                <div className="text-danger">{formik.errors.stock}</div>
              ) : null}
            </Col>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center justify-content-between gap-10">
                <label
                  htmlFor="status"
                  className="form-label text-dark fw-sbold m-0"
                >
                  Status
                </label>
                <Form.Check
                  type="switch"
                  id="status"
                  name="status"
                  checked={formik.values.status === "active"}
                  onChange={(e) =>
                    formik.setFieldValue(
                      "status",
                      e.target.checked ? "active" : "inactive"
                    )
                  }
                />
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Button
                className="d-flex align-items-center w-100 justify-content-center commonBtn"
                type="submit"
                disabled={formik.isSubmitting}
              >
                {mode === "create"
                  ? "Add Master Planet"
                  : "Update Master Planet"}
              </Button>
            </Col>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddNewMasterPlanet;
